// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateTextElementShadowReducer extends Reducer
{
	public static reducerName: string = "UpdateTextElementShadow";
	public static call(_elementId: number, _css: string) {
		this.getReducer().call(_elementId, _css);
	}

	public call(_elementId: number, _css: string) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _cssType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_cssType, _css);
		this.client.call("UpdateTextElementShadow", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let cssType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let cssValue = AlgebraicValue.deserialize(cssType, adapter.next())
		let css = cssValue.asString();
		return [elementId, css];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _css: string) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _css: string) => void)
	{
		this.client.on("reducer:UpdateTextElementShadow", callback);
	}
}


export default UpdateTextElementShadowReducer
